export default __webpack_public_path__ + "static/media/men.7a19373e.jpg";